import React from 'react'

export default function OrderCancelReasonBox({ order, onChange }) {
  const reasons = [
    '',
    'ไม่แนบสลิป',
    'รูปที่แนบไม่ใช่สลิป',
    'สลิปซ้ำ',
    'ยอดเงินไม่ตรง',
    'สลิปปลอม',
    'บัญชีไม่ตรง',
    'ไม่สามารถตรวจสอบรายการได้',
    'ลูกค้ายกเลิก',
    'อื่นๆ',
  ]
  function handleOnChangeReason(e) {
    const elReasonEtc = document.querySelector('#reason_etc')
    switch (e.target.value) {
      case 'อื่นๆ':
        onChange('')
        const elReasonEtcInput = document.createElement('input')
        elReasonEtcInput.style.display = 'flex'
        elReasonEtcInput.style.width = '100%'
        elReasonEtcInput.style.border = '1px solid #f0f1f5'
        elReasonEtcInput.style.padding = '0px 8px'
        elReasonEtcInput.style.marginTop = '4px'
        elReasonEtcInput.style.fontSize = '0.75rem'
        elReasonEtcInput.style.height = '35px'
        elReasonEtc.innerHTML = ''
        elReasonEtc.appendChild(elReasonEtcInput)
        elReasonEtcInput.focus()
        elReasonEtcInput.addEventListener('input', (e) => {
          onChange(e.target.value)
        })
        break
      default:
        elReasonEtc.innerHTML = ''
        onChange(e.target.value)
        break
    }
  }
  return (
    <>
      <div className="d-flex w-100 align-items-center justify-content-between mb-2" style={{ height: '40px' }}>
        <label className="d-flex mb-0" style={{ width: '210px', minWidth: '210px' }}>
          เหตุผล :
        </label>
        {order.cancelReason && order.cancelReason !== '' ? (
          <div className="d-flex">{order.cancelReason}</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <div
              style={{
                display: 'flex',
                fontSize: '0.75rem',
                height: '35px',
                color: '#000',
                border: '1px solid #f0f1f5',
                padding: '0px 8px',
              }}
            >
              <select onChange={(e) => handleOnChangeReason(e)} style={{ border: '0px', width: '100%' }}>
                {reasons.map((reason, i) => (
                  <option key={`reason_${i}`} value={reason}>
                    {reason}
                  </option>
                ))}
              </select>
            </div>
            <div id="reason_etc" style={{ display: 'flex' }}></div>
          </div>
        )}
      </div>
    </>
  )
}
